import React, { useMemo } from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import { useMediaQuery } from 'react-responsive'
import { Link, useParams } from 'react-router-dom'
import block from 'bem-cn'

import { MODAL_ROUTE_PATH, MODAL_ROUTE_URLS } from 'router/modalRoutes'

import { ReactComponent as CloseSVG } from 'shared/img/closeX.svg'

import { localeCommonKeysType } from 'shared/locale/en-US'
import { mediaSize } from 'shared/style/var'
import { getRouteParamsByStrings } from 'shared/utils/getRouteParamsByStrings'

import { selectLocaleDict } from 'features/locale/selectors'

import { useModalContext } from 'components/HOC/withModalQuery/ModalContext'

import { choiceofSport } from './data'
import { ChoiceOfSport } from './types'

import './SportModal.scss'

const b = block('sport-modal')

const SportModal: React.FC<{ path?: string }> = ({ path = '' }) => {
  const params = getRouteParamsByStrings<{ type: ChoiceOfSport }>(MODAL_ROUTE_PATH.CHOOSE_SPORT, path)
  const { closeModal } = useModalContext()
  const isMobileOrTablet = useMediaQuery({ maxWidth: mediaSize.tablet })

  const locale = useSelector(selectLocaleDict, shallowEqual).common

  const items = useMemo(
    () =>
      choiceofSport[params?.type as ChoiceOfSport].map(item => (
        <Link className={b('item')} to={isMobileOrTablet && item.mobileLink ? item.mobileLink : item.link}>
          {item.icon && <item.icon className={b('item-icon')} />}
          <div className={b('text')}>{locale[item.text]}</div>
        </Link>
      )),
    [isMobileOrTablet, locale, params],
  )

  return (
    <div className={b()}>
      <div className={b('header')}>
        <h2 className={b('header-title')}>{locale.chooseSport}</h2>
        <CloseSVG onClick={closeModal(MODAL_ROUTE_URLS.CHOOSE_SPORT(params?.type!!))} className={b('header-cross')} />
      </div>
      <div className={b('items')}>{items}</div>
    </div>
  )
}

export default SportModal
